const SectionTitle = ({ eyebrow, title, description, align = "left" }) => {
  return (
    <div
      className={`space-y-3 mb-10 ${
        align === "center" ? "text-center mx-auto max-w-3xl" : "text-left"
      }`}
    >
      {eyebrow && (
        <span className="text-sm uppercase tracking-[0.3em] text-brand-gold/80">
          {eyebrow}
        </span>
      )}
      <h2 className="text-3xl md:text-4xl font-display text-brand-cream">
        {title}
      </h2>
      {description && (
        <p className="text-brand-cream/70 leading-relaxed">{description}</p>
      )}
    </div>
  );
};

export default SectionTitle;
